import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { any, objectOf } from 'prop-types';
import { Button, Link } from '@s7/ui-kit';
var allowedButtonTypes = ['submit', 'reset', 'button'];

var getButtonType = function getButtonType(type) {
  return allowedButtonTypes.includes(type) ? type : 'button';
};

var ACTIONS_BY_TYPE = {
  button: Button,
  link: Link
};

var AuthorizationGroupButton = function AuthorizationGroupButton(_ref) {
  var action = _ref.action,
      form = _ref.form;

  if ( /*#__PURE__*/React.isValidElement(action)) {
    return action;
  }

  if (typeof action === 'function') {
    return /*#__PURE__*/React.createElement(action, {
      form: form
    });
  }

  return /*#__PURE__*/React.createElement(ACTIONS_BY_TYPE[action.type || 'button'] || Button, _objectSpread(_objectSpread({}, action), {}, {
    type: getButtonType(action.type)
  }));
};

AuthorizationGroupButton.propTypes = {
  action: objectOf(any),
  form: objectOf(any)
};
export default /*#__PURE__*/React.memo(AuthorizationGroupButton);